<template>
    <div
        v-if="projectLockStore.lockedForProjectTable"
        class="d-flex justify-content-center">
        <div>{{ progressMessage }}</div>
        <a
            v-if="projectLockStore.canCancelProjectTableImport"
            class="ms-2"
            href="#"
            v-on:click="cancelImport">
            {{ cancelImportHeader }}
        </a>
    </div>
</template>

<script setup>
    import { computed, inject } from "vue";
    import { PC_RES_SYMBOL, PAGE_APP_SYMBOL } from "_Main/injectionSymbols";
    import { useProjectLockStore } from "Projects/projectLockStore.js";
    import { KEYS, NAMESPACE } from "./i18n/projectTableProgressMessage.i18n";
    import { useResource } from "Util/i18n";

    const app = inject(PAGE_APP_SYMBOL);
    const res = inject(PC_RES_SYMBOL);
    const projectLockStore = useProjectLockStore();
    const { processingMessage, cancelImportHeader, cancelImportMessage, cancellingImportMessage } = useResource(
        KEYS,
        NAMESPACE
    );

    const progressMessage = computed(() => {
        if (!projectLockStore.projectTableOperationProgress) {
            return processingMessage.value;
        }

        const processedItems = projectLockStore.projectTableOperationProgress.ProcessedItemCount;
        const totalItems = projectLockStore.projectTableOperationProgress.TotalItemCount;
        if (!totalItems || !processedItems) {
            return processingMessage.value;
        }

        return res({
            namespace: NAMESPACE,
            key: KEYS.processedCountMessage,
            values: { processedCount: processedItems, totalCount: totalItems }
        });
    });

    async function cancelImport() {
        const confirmResult = await app.showConfirmationDialog(cancelImportHeader.value, cancelImportMessage.value);
        if (confirmResult) {
            app.blockUi(cancellingImportMessage.value);
            try {
                await projectLockStore.cancelProjectTableImport();
            } finally {
                app.unBlockUi();
            }
        }
    }
</script>
